<template>
  <div class="imgShare">
    <div class="imgShare-app" v-if="isApp">
      <!-- 高度太高，部分机型和海报重叠 -->
      <ul class="imgShare-ways">
        <li v-for="(item, index) in waysArr" :key="index" @click="callAppShareImg(item.scence)">
          <span :class="item.type"></span>
          <p>{{item.name}}</p>
        </li>
      </ul>
    </div>
    <!-- End: 原生app内分享 -->
    <!-- 微信和其他浏览器长按保存 -->
    <div class="imgShare-web" v-else>
      <div class="imgShare-prompt">
        <output>长按保存海报</output> 分享给好友 有机会获得返学费奖励哦～
      </div>
      <img src="../assets/images/monkey.png" alt />
    </div>
  </div>
</template>

<script>
import { mixin_shareReward } from '../mixin/mixin'

export default {
  name: 'imgShare',
  mixins: [mixin_shareReward],
  props: {
    // 分享出去的图片链接
    imgUrl: {
      required: true,
      type: String,
      default: ''
    }
  },
  data () {
    return {
      shareState: false,
      isApp: /jzh$/i.test(navigator.userAgent), // 是否是原生app
      waysArr: [
        { type: 'wechat', name: '微信好友', scence: '1' },
        { type: 'timeline', name: '微信朋友圈', scence: '2' }
      ]
    }
  },
  created () {
    if (/\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(navigator.userAgent)) {
      this.waysArr.push({ type: 'qq', name: 'QQ好友', scence: '4' })
    }
  },
  methods: {
    // 调用app分享。 埋点父组件添加其它参数：比如posterId 等
    callAppShareImg (scence) {
      this.$emit('shareClick', scence)
      const appShareConfig = {
        agentKey: '', // 项目日志自定义统计key
        shareType: 2, // 1.网页，2大图，3小程序
        businessId: 2018, // 项目对于业务ID
        shareScence: scence, // 分享渠道,二进制转换 000000 ~ 111111
        isOneKeyShare: true, // 是否一键分享
        imagePath: this.imgUrl, // 大图网络路径
        title: '好友邀你上名师课，购课立减200元！', // 分享标题
        desc: '清北哈佛毕业名师，十余年教学经验，让孩子每天进步一点点！' // 分享描述
      }
      xesApp.appShareBack = res => {
        this.$emit('appShareBack', { scence, status: res })
        if (this.shareState) return
        this.shareState = true
        this.increaseShareCountForGold()
        setTimeout(() => { this.shareState = false }, 1000)
      }
      xesApp.start('xesShare/share', JSON.stringify(appShareConfig), 'xesApp.appShareBack')
    }
  }
}
</script>

<style lang="scss" scoped>
.imgShare {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  padding: 0 36px 15px;

  &-app {
    .imgShare-ways {
      display: flex;
      justify-content: space-around;

      & > li {
        display: flex;
        flex-direction: column;
        align-items: center;

        & > span {
          width: 41px;
          height: 41px;
          background-size: 100%;
          background-repeat: no-repeat;

          &.wechat {
            background-image: url("../assets/images/wechat_2x.png");
          }

          &.timeline {
            background-image: url("../assets/images/timeline_2x.png");
          }

          &.qq {
            background-image: url("../assets/images/qq_2x.png");
          }

          &.qzone {
            background-image: url("../assets/images/qzone_2x.png");
          }
        }

        p {
          margin-top: 6px;
          font-size: 10px;
          color: #a0a0a0;
        }
      }
    }
  }
  // ## 浏览器分享
  &-web {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    text-align: left;

    .imgShare-prompt {
      flex: 1;
      height: 70px; // 图片60，60+8+2
      padding: 8px 23px 2px 8px;
      font-size: 14px;
      font-weight: 300;
      line-height: 1.7;
      color: #ac5515;
      background: url('../assets/images/bg-msg.png') no-repeat;
      background-size: 100%;

      & > output {
        font-size: 16px;
        font-weight: 500;
      }
    }

    img {
      width: 61px;
    }
  }
}
</style>
